export type IsoTime = string & { __isoTimeBrand: void };
export type IsoTimeTz = string & { __isoTimeTzBrand: void };
export type IsoDate = string & { __isoDateBrand: void };
export type IsoDateTime = string & { __isoDateTimeBrand: void };
export type IsoDateTimeTz = string & { __isoDateTimeTzBrand: void };
export type IsoYear = string & { __isoYearBrand: void };
export type IsoYearAndMonth = string & { __isoYearAndMonthBrand: void };
export type IsoYearAndWeek = string & { __isoYearAndWeekBrand: void };
export type IsoYearAndWeekWithWeekday = string & { __isoWeekWithWeekdayBrand: void };
export type IsoTimeOffset = string & { __isoTimeOffsetBrand: void };

export type IsoDuration = string & { __isoDurationBrand: void };
export type IsoWeekDuration = string & { __isoWeekDurationBrand: void };
